import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Redirect } from "react-router-dom";
import { renderRoutes } from "./router/Routes";
import { PrivateRoute } from "./router/PrivateRoute";
import { Provider } from "react-redux";
import { Authorization } from "./utils/Functions";
import { paths } from "./router/Constant";
import store from "./store";
import "react-datepicker/dist/react-datepicker.css";

function App() {
  useEffect(() => {
    !Authorization() && <Redirect exact from="/" to={paths.login} />;
  }, []);
  return (
    <Provider store={store}>
      <div className="App h-100">
        <Router>
          <Switch>
            {renderRoutes.map(([key, route]) => {
              return (
                <PrivateRoute
                  key={key}
                  {...route} 
                  privateRoute={route.private}
                />
              );
            })}
            <Redirect to="/" />
          </Switch>
        </Router>
      </div>
    </Provider>
  );
}

export default App;
